import { useTranslation } from 'react-i18next';

export default function UseCases() {
  const { t } = useTranslation();

  const useCases = [
    {
      icon: 'ri-global-line',
      title: t('useCases.case1.title'),
      description: t('useCases.case1.desc'),
      gradient: 'from-purple-500 to-pink-500',
    },
    {
      icon: 'ri-wallet-3-line',
      title: t('useCases.case2.title'),
      description: t('useCases.case2.desc'),
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: 'ri-gamepad-line',
      title: t('useCases.case3.title'),
      description: t('useCases.case3.desc'),
      gradient: 'from-orange-500 to-red-500',
    },
    {
      icon: 'ri-store-2-line',
      title: t('useCases.case4.title'),
      description: t('useCases.case4.desc'),
      gradient: 'from-green-500 to-emerald-500',
    },
    {
      icon: 'ri-government-line',
      title: t('useCases.case5.title'),
      description: t('useCases.case5.desc'),
      gradient: 'from-indigo-500 to-purple-500',
    },
  ];

  return (
    <section id="use-cases" className="relative py-32 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
            {t('useCases.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('useCases.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-xl rounded-3xl p-8 border border-white/10 hover:border-emerald-500/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-emerald-500/20"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${useCase.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
                <i className={`${useCase.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">{useCase.title}</h3>
              <p className="text-gray-400 leading-relaxed mb-6">{useCase.description}</p>
              
              <div className="flex gap-2">
                <span className="px-3 py-1 bg-emerald-500/20 text-emerald-400 rounded-full text-xs font-semibold border border-emerald-500/30 whitespace-nowrap">
                  {t('useCases.badge1')}
                </span>
                <span className="px-3 py-1 bg-teal-500/20 text-teal-400 rounded-full text-xs font-semibold border border-teal-500/30 whitespace-nowrap">
                  {t('useCases.badge2')}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
